<template>
  <section class="users-filters ">
    <div class="section-title">
      <span @click="isOpen = !isOpen">
        {{ $t('users.listing.filters.title') }}
        <font-awesome-icon :icon="isOpen ? 'sort-up' : 'sort-down'" />
      </span>
    </div>

    <div v-show="isOpen">
      <div class="active-inactive-label">
        <TolSelect
          :options="searchFilters"
          :placeholder="$t('users.listing.filters.all')"
          :selected="selectedFilter"
          @change="onFilterChange"
        />
      </div>
    </div>
  </section>
</template>

<script>
import TolSelect from '@/app/components/TolSelect';
import { UsersListingGetters } from '../users-listing-keys';

export default {
  components: {
    TolSelect
  },

  data() {
    return {
      isOpen: false,
      searchFilters: [
        {
          label: 'active',
          value: 'true'
        },
        {
          label: 'inactive',
          value: 'false'
        },
        {
          label: 'both',
          value: 'null'
        }
      ]
    };
  },

  computed: {
    selectedFilter() {
      return this.searchFilters.filter(
        e => e.value == this.$store.getters[UsersListingGetters.UsersActiveInactive]
      );
    }
  },

  methods: {
    onFilterChange(activeInactive) {
      this.$emit('change', activeInactive);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../styles/colors.scss';
@import '../../../../styles/variables.scss';

.users-filters {
  background-color: $background-level-2;
  .section-title {
    font-size: 22px;
    font-weight: bold;
    letter-spacing: -0.22px;
    line-height: 25px;
    margin-bottom: 20px;
    padding: 60px;
    display: flex;
    justify-content: space-between;

    > span {
      cursor: pointer;
    }
  }

  .active-inactive-label {
    display: flex;

    padding-left: 60px;
    padding-bottom: 5px;
  }
  .no-box {
    border: 0;
  }
}
</style>
